import { SlateApiReturn } from 'modules/editor';
import React from 'react';
import Icon from 'react-icons-kit';
import { link } from 'react-icons-kit/fa/link';
import { unlink } from 'react-icons-kit/fa/unlink';
import { Button } from 'shared/components';
import { isLinkActive } from 'shared/utils';
import { useSlateStatic } from 'slate-react';
import { RichTextToolbarTooltip } from '../RichTextToolbarTooltip';
import { RichTextToolbarLinkModal } from './RichTextToolbarLinkModal';

interface Props {
  editorApi: SlateApiReturn;
  label: string;
  shortcut: string;
}

export const RichTextToolbarLinkButton: React.FC<Props> = ({
  editorApi,
  label,
  shortcut,
}) => {
  const editor = useSlateStatic();
  const isActive = isLinkActive(editor);
  const tooltipLabel = isActive ? 'Remove Link' : label;

  const {
    onSetText,
    onSetUrl,
    handleLinkMouseDown,
    handleSave,
    linkModal: { isModalOpen, closeModal },
    url,
    text,
  } = editorApi;

  function getIcon() {
    if (isActive) return unlink;
    return link;
  }

  let className = 'slate__toolbar__icon';
  if (isActive) className += ' slate__toolbar__icon--active';

  return (
    <>
      <Button
        type="button"
        className={className}
        onMouseDown={handleLinkMouseDown}
        btnSelector="slate-link-btn"
        ariaLabel={`${tooltipLabel}. Shortcut ${shortcut}`}
      >
        <Icon icon={getIcon()}>{getIcon()}</Icon>
        <RichTextToolbarTooltip label={tooltipLabel} shortcut={shortcut} />
      </Button>

      {isModalOpen && (
        <RichTextToolbarLinkModal
          defaultUrl={url}
          defaultText={text}
          onHandleSave={handleSave}
          onClose={closeModal}
          onSetText={onSetText}
          onSetUrl={onSetUrl}
        />
      )}
    </>
  );
};
